import axios from 'axios';
import { config } from '../../config';

export default {
    namespaced: true, // Activa el namespacing para este módulo

    actions: {
        async galeria_updateTraslado(_, formData) {
            return new Promise((resolve, reject) => {
                axios.post(config.apiUrl + '/galeria/update-traslado', formData)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        async galeria_getTraslado() {
            return new Promise((resolve, reject) => {
                axios.get(config.apiUrl + '/galeria/get-traslado')
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        async galeria_uploadPhotos(_, formData) {
            return new Promise((resolve, reject) => {
                axios.post(config.apiUrl + '/galeria/upload-photos', formData)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        async galeria_uploadVideo(_, formData) {
            return new Promise((resolve, reject) => {
                axios.post(config.apiUrl + '/galeria/upload-video', formData)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        async galeria_getPhotos(_, formData) {
            return new Promise((resolve, reject) => {
                axios.get(config.apiUrl + '/galeria/get-photos?name='+formData.name)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        async galeria_getVideoNames() {
            return new Promise((resolve, reject) => {
                axios.get(config.apiUrl + '/galeria/get-video-names')
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        async galeria_deletePhoto(_, id) {
            return new Promise((resolve, reject) => {
                axios.delete(`${config.apiUrl}/galeria/delete-photo/${id}`)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        async galeria_deleteVideo(_, id) {
            return new Promise((resolve, reject) => {
                axios.delete(`${config.apiUrl}/galeria/delete-video/${id}`)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        }
    }
}
